import { render, staticRenderFns } from "./addPassportUser.vue?vue&type=template&id=2cca8b6c&scoped=true"
import script from "./addPassportUser.vue?vue&type=script&lang=js"
export * from "./addPassportUser.vue?vue&type=script&lang=js"
import style0 from "./addPassportUser.vue?vue&type=style&index=0&id=2cca8b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cca8b6c",
  null
  
)

export default component.exports